var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider",style:(`height: ${_vm.height}px; background-color: var(--${_vm.backgroundColor})`)})
}
var staticRenderFns = []

export { render, staticRenderFns }